import { AxiosError } from 'axios';
import { useEffect } from 'react';
import { useMutation } from 'react-query';
import { useHistory, useParams } from 'react-router';
import { routes } from '@/constant/routes.const';
import {
  fetchMedicalHome,
  medicalPassportValidate,
  verifyMedicalEmail,
} from '@/api';
import LoadingView from '@/components/common/LoadingView';
import { useAppDispatch } from '@/hooks/useReduxHooks';
import {
  IMedicalPassportValidateRespones,
  IVerifyEmailPayload,
} from '@/types/common.type';
import {
  IMedicalHomePayload,
  IMedicalHomeResponse,
} from '@/types/medical.type';
import { useLocation } from 'react-router';
import { isNationIncluded } from '@repo/utils';
import { MAIN_NATIONS } from '@repo/constants';

type Props = {
  id: string;
  verifiedEmail: string;
};
function MedicalVerifiactionRedirect() {
  const { id, verifiedEmail } = useParams() as Props;
  const passportNumber = id.toUpperCase();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const selectedAirport = searchParams.get('airport') || 'false';
  const isInquiry = searchParams.get('inquiry') || 'false';

  const passportMutation = useMutation<
    IMedicalPassportValidateRespones,
    AxiosError,
    string
  >((payload) => medicalPassportValidate(payload), {
    retry: false,
    onSuccess: (data) => onSuccessPassport(data),
  });

  const onSuccessPassport = (data: IMedicalPassportValidateRespones) => {
    const { departureDate, customerNation, ...rest } = data;

    dispatch({
      type: 'UPDATE_USER_INFO',
      payload: {
        passportNumber,
        nationality: customerNation,
        ...rest,
      },
    });

    departureDate &&
      localStorage.setItem('medicalDepartureDate', departureDate);
    customerNation &&
      localStorage.setItem('medicalCustomerNation', customerNation);
    localStorage.setItem('login', passportNumber);

    verifyMutation.mutate(
      { passportNumber, verifiedEmail },
      {
        onSuccess: onSuccessVerify,
        onError: () => {
          alert('이메일 인증에 실패하였습니다. 다시 시도해주세요.');
        },
      },
    );
  };

  const verifyMutation = useMutation<number, AxiosError, IVerifyEmailPayload>(
    (payload) => verifyMedicalEmail(payload),
    {
      retry: false,
    },
  );

  const onSuccessVerify = () => {
    dispatch({
      type: 'UPDATE_USER_INFO',
      payload: {
        verifiedEmail,
        email: verifiedEmail,
      },
    });
    if (isInquiry === 'true' || selectedAirport === 'true') {
      return history.push(routes.inquiryQna);
    }
    history.push(routes.medicalCustomerRefund);
  };

  const { mutate: homeMutation } = useMutation<
    IMedicalHomeResponse,
    AxiosError,
    IMedicalHomePayload
  >((payload) => fetchMedicalHome(payload), {
    retry: false,
    onSuccess: ({
      isRegister,
      isRead,
      paymentStatus,
      isVincentJpn,
      ...rest
    }) => {
      dispatch({
        type: 'UPDATE_USER_INFO',
        payload: {
          isRefundInfoRegistered: isRegister,
          haveSeenReceipt: isRead,
          paymentStatus,
          ...rest,
        },
      });
    },
  });

  const fetchHome = () => {
    homeMutation({ passportNumber: passportNumber as string });
  };

  useEffect(() => {
    passportMutation.mutate(passportNumber as string);
    fetchHome();
  }, []);

  return <LoadingView />;
}

export default MedicalVerifiactionRedirect;
